export default __webpack_public_path__ + "static/media/linkedin.7d58443f.jpg";